import { ApiType } from "@gymflow/common";
import { zonedTimeToUtc } from "@gymflow/helpers";
import { VisitPercentageDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { reportQueryKeys } from "./reportQueryKeys";

export interface UseQueryVisitPercentageProps {
  api: ApiType;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  size?: number;
  tz: string;
}

export function useQueryVisitPercentage(
  { api, dateFrom, dateTo, tz }: UseQueryVisitPercentageProps,
  queryOpts?: Omit<UseQueryOptions<VisitPercentageDTO>, "queryKey">,
) {
  const result = useQuery({
    queryKey: reportQueryKeys.visitPercentage({
      dateFrom,
      dateTo,
    }),
    queryFn: async () => {
      const result = await api.accessApi.visitPercentage({
        dateFrom: zonedTimeToUtc(dateFrom as string, tz),
        dateTo: zonedTimeToUtc(dateTo as string, tz),
      });
      return result.data;
    },
    enabled: !!tz && !!dateFrom && !!dateTo,
    ...queryOpts,
  });
  return result;
}
